var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data",style:('background:' + _vm.ownerSurfaceColor)},[_c('v-layout',{staticClass:"my-2",style:('color:' + _vm.ownerSurfaceColor),attrs:{"column":"","align-center":""}},[_c('v-img',{class:{
        'image-big': !_vm.small && !_vm.medium && !_vm.xsmall,
        'image-medium': _vm.medium,
        'image-small': _vm.small,
        'image-x-small': _vm.xsmall,
      },attrs:{"src":_vm.src,"contain":""}}),_c('v-layout',{attrs:{"justify-center":""}},[_c('span',{staticClass:"no-data__text mb-2",class:_vm.xsmall ? '' : 'mt-6',style:('color:' + _vm.ownerOnSurfaceColor),domProps:{"innerHTML":_vm._s(_vm.title)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }